function AuthorizationProcessor(processorOrderId, processorTransactionId, reasonCode, reasonDescription) {
  if (processorOrderId !== undefined) {
    this.ProcessorOrderId = processorOrderId;
  }
  if (processorTransactionId !== undefined) {
    this.ProcessorTransactionId = processorTransactionId;
  }
  this.ReasonCode = reasonCode;
  this.ReasonDescription = reasonDescription;
}

module.exports = AuthorizationProcessor;


//////////////////
// WEBPACK FOOTER
// ./models/authorizationProcessor.js
// module id = 44
// module chunks = 0 5 20